import { EmailDashboardCard } from "@/components/Card";
import { H3 } from "@/components/Typography";
import { getTopLevelCardsStats } from "@/utils/emailDashboardMetricsHelper";
import {
  faShieldCheck,
  faUsers,
  faUserCheck,
  faUserPlus,
  faDollarCircle,
  faArrowsRotate,
} from "@fortawesome/pro-duotone-svg-icons";
import { useTranslation } from "react-i18next";

interface IProps {
  data: IGetEmailDashboardRS;
}

const TopLevelCards = ({ data }: IProps) => {
  const { t } = useTranslation();
  const {
    marketingConsentRate,
    verifiedContacts,
    subscribedContacts,
    incrementalSubscribers,
    repeatPurchases,
    repeatPurchaseRevenue,
  } = getTopLevelCardsStats(data?.rawData);

  return (
    <>
      <div className="mb-30 grid grid-cols-1 gap-20 sm:grid-cols-4">
        <EmailDashboardCard
          icon={faShieldCheck}
          title={t("email.dashboard.tiles.mcr.title")}
          value={marketingConsentRate}
          tooltip={t("email.dashboard.tiles.mcr.tooltip")}
          isPercent
        />

        <EmailDashboardCard
          icon={faUsers}
          title={t("email.dashboard.tiles.verifiedContacts.title")}
          value={verifiedContacts}
          tooltip={t("email.dashboard.tiles.verifiedContacts.tooltip")}
        />

        <EmailDashboardCard
          icon={faUserCheck}
          title={t("email.dashboard.tiles.subscribedContacts.title")}
          value={subscribedContacts}
          tooltip={t("email.dashboard.tiles.subscribedContacts.tooltip")}
        />

        <EmailDashboardCard
          icon={faUserPlus}
          title={t("email.dashboard.tiles.incrementalSubscribers.title")}
          value={incrementalSubscribers}
          tooltip={t("email.dashboard.tiles.incrementalSubscribers.tooltip")}
        />
      </div>

      <H3 className="mb-5 font-bold">
        {t("email.dashboard.titles.repeatPurchase")}
      </H3>
      <hr className="mb-20" />
      <div className="mb-30 grid grid-cols-1 gap-20 sm:grid-cols-2">
        <EmailDashboardCard
          icon={faDollarCircle}
          title={t("email.dashboard.tiles.repeatPurchasers.title")}
          value={repeatPurchases}
          tooltip={t("email.dashboard.tiles.repeatPurchasers.tooltip")}
        />

        <EmailDashboardCard
          icon={faArrowsRotate}
          title={t("email.dashboard.tiles.repeatPurchaseRevenue.title")}
          value={repeatPurchaseRevenue}
          tooltip={t("email.dashboard.tiles.repeatPurchaseRevenue.tooltip")}
          isCurrency
          currency={data?.shopCurrency}
        />
      </div>
    </>
  );
};

export default TopLevelCards;
